export * from './question.drawable';
export * from './slider.drawable';
